import React from 'react';
import MediaContainer from 'shared/components/MediaContainer/MediaContainer';
import { IProjectAttributes } from 'shared/interfaces/IProject';
import { useStyles } from '../Project.styles';
import { CustomTypography } from 'shared/elements/CustomTypography';

type Props = {
  data: IProjectAttributes | undefined;
};

const AdditionalDetails: React.FC<Props> = ({ data }) => {
  const classes = useStyles();

  if (data === undefined) return <React.Fragment />;
  return (
    <div>
      <CustomTypography className={classes.heading}>Additional Details</CustomTypography>
      {(data && data?.medium_attachments.length > 0) || data?.additional_details ? (
        <div>
          {data?.additional_details ? (
            <div className={classes.flexRow}>
              <CustomTypography fontSize={13} style={{ whiteSpace: 'break-spaces' }}>
                {data?.additional_details}
              </CustomTypography>
            </div>
          ) : (
            <React.Fragment />
          )}
          {data?.medium_attachments.length > 0 ? (
            <div className={classes.flexRow}>
              {data?.medium_attachments.map((i) => <MediaContainer key={i.id} media={i} />)}
            </div>
          ) : (
            <React.Fragment />
          )}
        </div>
      ) : (
        <CustomTypography color="mainGray" fontSize={14}>
          No Additional Details Available
        </CustomTypography>
      )}
    </div>
  );
};

export default AdditionalDetails;
